import React, { useState, useEffect } from "react";
import { Modal, Input, Checkbox, Button, Row, Col, Form } from "antd";
import { CargoCraneOptions } from "../../../../../Data/data"; // Renamed from IGGOptions

const AddCargoCraneModal = ({ visible, onOk, onCancel, responseData, errors }) => {
  const [form] = Form.useForm();
  const [selectedParams, setSelectedParams] = useState([]);
  const [customParams, setCustomParams] = useState([]);

  useEffect(() => {
    try {
      const defaultParams =
        responseData?.selected_parameters || CargoCraneOptions.map((param) => param.value);
      setSelectedParams(defaultParams);
      if (responseData) {
        form.setFieldsValue({
          crane_name: responseData?.crane_name || responseData?.C_crane_name || "",
          crane_maker: responseData?.crane_maker || responseData?.C_crane_maker || "",
          crane_model: responseData?.crane_model || responseData?.C_crane_model || "",
        });
        setCustomParams(
          Array.isArray(responseData?.other_parameters) ? responseData.other_parameters : []
        );
      }
    } catch (error) {
      console.error("Error setting responseData:", error);
    }
  }, [responseData, form]);

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      const fieldErrors = Object.keys(errors).map((key) => ({
        name: key,
        errors: [errors[key]],
      }));
      form.setFields(fieldErrors);
    }
  }, [errors, form]);

  const handleAddParam = () => {
    setCustomParams([...customParams, { name: "", unit: "" }]);
  };

  const handleCustomChange = (index, field, value) => {
    const updated = [...customParams];
    updated[index][field] = value;
    setCustomParams(updated);
  };

  const handleDeleteParam = (index) => {
    setCustomParams(customParams.filter((_, i) => i !== index));
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        const data = {
          ...values,
          selectedParams,
          customParams,
          machinery_dropdown: "Cargo Crane", // Ensure machinery_type is not undefined
        };
        onOk(data);
        form.resetFields();
        setSelectedParams(CargoCraneOptions.map((param) => param.value));
        setCustomParams([]);
      })
      .catch((errorInfo) => {
        console.log("Validation Failed:", errorInfo);
      });
  };

  const safeCargoCraneOptions =
    Array.isArray(CargoCraneOptions) && CargoCraneOptions.length > 0 ? CargoCraneOptions : [];

  return (
    <Modal
      title="Add Cargo Crane Details"
      visible={visible}
      onCancel={() => {
        onCancel();
      }}
      onOk={handleSubmit}
      okText="Save"
    >
      <Form
        layout="vertical"
        form={form}
        onValuesChange={(changedValues) => {
          Object.keys(changedValues).forEach((key) => {
            form.setFields([{ name: key, errors: [] }]);
          });
        }}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item label="Crane Name" name="crane_name">
              <Input placeholder="Crane Name" maxLength={50} />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label="Crane Maker" name="crane_maker">
              <Input placeholder="Crane Maker" maxLength={50} />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label="Crane Model" name="crane_model">
              <Input placeholder="Crane Model" maxLength={50} />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label="Select Cargo Crane Parameters to Log">
              {safeCargoCraneOptions.length > 0 ? (
                <Checkbox.Group
                  value={selectedParams}
                  onChange={(values) => {
                    setSelectedParams(values);
                  }}
                  style={{ width: "100%" }}
                >
                  <Row gutter={[8, 8]}>
                    {safeCargoCraneOptions.map((param) => (
                      <Col span={12} key={param.value}>
                        <Checkbox value={param.value}>{param.label}</Checkbox>
                      </Col>
                    ))}
                  </Row>
                </Checkbox.Group>
              ) : (
                <div style={{ color: "red" }}>No Cargo Crane parameters available</div>
              )}
            </Form.Item>
          </Col>

          <Col span={24}>
            <div style={{ marginTop: 16 }}>
              <b>Add Other Parameters</b>
              {customParams.map((param, index) => (
                <Row gutter={8} key={index} style={{ marginTop: 8 }}>
                  <Col span={10}>
                    <Input
                      placeholder="Parameter"
                      value={param.name}
                      maxLength={50}
                      onChange={(e) => handleCustomChange(index, "name", e.target.value)}
                    />
                  </Col>
                  <Col span={10}>
                    <Input
                      placeholder="Unit"
                      value={param.unit}
                      maxLength={10}
                      onChange={(e) => handleCustomChange(index, "unit", e.target.value)}
                    />
                  </Col>
                  <Col span={4}>
                    <Button danger onClick={() => handleDeleteParam(index)} block>
                      ×
                    </Button>
                  </Col>
                </Row>
              ))}
              <Button type="dashed" onClick={handleAddParam} style={{ marginTop: 12 }}>
                + Add Parameter
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddCargoCraneModal;
